import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Container } from 'src/components/common/Container'
import { Typography } from 'src/components/common/Typography'
import { Noto_body1_r16 } from 'src/styles/fonts/NotoSansKrFonts'
import Button, { ButtonOption1 } from 'src/components/common/Button'
import styled from 'styled-components'
import { layoutMaxSize } from 'src/styles/mixin'
import useParamsType from 'src/hooks/useParamsType.hook'
import useLocalStorage from 'src/hooks/useLocalStorage.hook'
import { useCookies } from 'react-cookie'

const PassFinishPageView = () => {
  const { pass_channel } = useParamsType()
  const [passWindowHistoryPoint, , removePassWindowHistoryPoint] = useLocalStorage<number>(
    'pass_window_history_point',
    0,
  )
  const navigate = useNavigate()
  const [cookies] = useCookies(['req_num'])

  useEffect(() => {
    handleFinishPass()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleFinishPass = () => {
    if (pass_channel === 'aos' || !!cookies['req_num']) {
      navigate(!!passWindowHistoryPoint ? passWindowHistoryPoint - window.history.length : -4)
      removePassWindowHistoryPoint()
    } else if (pass_channel === 'ios') {
      window.location.href = 'couponwalletapp://payment_return'
    } else {
      window.open('', '_self', '')
      window.close()
    }
  }

  return (
    <S.PassFinishContainer $option="flex_column">
      <S.PassFinishContents $option="flex_column">
        <Container $option="flex_column" $row_gap="20px">
          <Typography $fontStyle={Noto_body1_r16}>
            요청하신 앱/웹브라우저로 이동하면 인증이 완료됩니다.
          </Typography>
        </Container>
        <S.PassFinishButtonWrap>
          <Button option={ButtonOption1('default')} onClickFn={handleFinishPass}>
            확인
          </Button>
        </S.PassFinishButtonWrap>
      </S.PassFinishContents>
    </S.PassFinishContainer>
  )
}
export default PassFinishPageView

const S = {
  PassFinishContainer: styled(Container)`
    ${layoutMaxSize};
    background-color: var(--white);
    margin: 0 auto;
    overflow: auto;
    min-height: calc(var(--vh, 1vh) * 100);
    height: 100%;
    align-items: center;
  `,
  PassFinishContents: styled(Container)`
    max-width: 320px;
    flex: 1;
    align-items: center;
    justify-content: center;
    text-align: center;
    margin: 0 auto;
    gap: 70px;
    padding: 0 20px;
  `,
  PassFinishButtonWrap: styled(Container)`
    padding: 0 10px;
  `,
}
